module.exports = __webpack_public_path__ + "static/media/gametree_active.62f7acea.png";